/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_LabelInputs */

const en_portal_nav_label = /** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client portal`)
};

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const ar_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const he_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const ur_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const es_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const fr_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const de_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const pt_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const hi_portal_nav_label = en_portal_nav_label;

/** @type {(inputs: Portal_Nav_LabelInputs) => LocalizedString} */
const bn_portal_nav_label = en_portal_nav_label;

/**
* | output |
* | --- |
* | "Client portal" |
*
* @param {Portal_Nav_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_nav_label = /** @type {((inputs?: Portal_Nav_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_nav_label(inputs)
	if (locale === "he") return he_portal_nav_label(inputs)
	if (locale === "ur") return ur_portal_nav_label(inputs)
	if (locale === "es") return es_portal_nav_label(inputs)
	if (locale === "fr") return fr_portal_nav_label(inputs)
	if (locale === "de") return de_portal_nav_label(inputs)
	if (locale === "pt") return pt_portal_nav_label(inputs)
	if (locale === "hi") return hi_portal_nav_label(inputs)
	if (locale === "bn") return bn_portal_nav_label(inputs)
	return /** @type {LocalizedString} */ ("Client portal")
});